import {AuthenticationPageLayout} from 'pages/common/authentication/AuthenticationPageLayout';

import {Form} from './components/Form';

export const OktaLoginPage = () => (
    <AuthenticationPageLayout>
        <Form />
    </AuthenticationPageLayout>
);
